// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canGenerateRegistrationToken } from "./check";

export function useCanGenerateRegistrationToken(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction =
    !!withinScope && canGenerateRegistrationToken(withinScope);
  return canDoAction;
}
